<template>
  <div class="NotFound-box">
		<div class="div_404_img">
			<img src="https://cdn.shopify.com/s/files/1/0737/0578/3585/files/404_page_2.png?v=1724146558" alt="404 img">
		</div>
		<div class="div_sorry_text">{{ $t('page_404.SORRY') }}</div>
		<div class="div_looking_text">{{ $t('page_404.check_text') }}</div>
		<div class="div_404_btn_box">
			<h2 class="div_404_btn back_to_gome" @click="BackToHome()">
				{{ $t('page_404.Back_Home') }}
			</h2>
			<h2 class="div_404_btn go_to_support" href="" @click="$go_official_website_page('/pages/support')">
				{{ $t('page_404.Get_Support') }}
			</h2>
		</div>
  </div>
</template>
	
<script>

export default {
	name: 'not-found',
	
	data() {
		return {
			
		}
	},
	
	// 监听
	watch: {
		// "searchText": {
		// 	handler: function (newValue, oldValue) {
		// 		if(this.searchText && this.searchText != ''){
		// 			this.icon_search = false
		// 		}else{
		// 			this.icon_search = true
		// 		}
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
	  
	},
  
	methods:{
		BackToHome(){
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.div_sorry_text {
	   color: #06f;
		// color: #2094FA;
	   text-align: center;
	   font-weight: 700;
	   line-height: 1;
	}
	.div_looking_text {
		color: #111111;
		text-align: center;
		font-weight: 500;
		line-height: 1.5;
		max-width: 420px;
		text-align: center;
	}
	.div_404_btn{
		padding: 10px 15px;
		line-height: 1;
		border-radius: 30px;
		font-size: 14px;
		min-width: 150px;
		max-width: 180px;
		text-align: center;
		cursor: pointer;
	}
	.back_to_gome {
	   background: #000000;
	   color: #ffffff;
	   border: 1px #000000 solid;
	}
	.go_to_support {
	    background: #ffffff;
	    color: #000000;
	    border: 1px #000000 solid;
	}
	@media screen and (min-width: 1024px) {
		.NotFound-box {
			width: 100%;
			padding: 10px 10px;
			background-color: #ffffff;
		}
		.div_sorry_text {
			margin-top: 28px;
			font-size: 28px;
		}
		.div_looking_text {
			margin: auto;
		   margin-top: 18px;
		   font-size: 16px;
		}
		.div_404_img{
			padding: 30px 0px;
			width: 100%;
			max-width: 500px;
			margin: auto;
			img{
				width: 100%;
			}
		}
		.div_404_btn_box{
			margin: auto;
			margin-top: 10px;
			width: 100%;
			max-width: 320px;
			padding: 20px 0px;
			display: flex;
			justify-content: space-between;
		}
	}
	@media screen and (max-width: 1024px) {
		.NotFound-box {
			width: 100%;
			padding: 0px;
			background-color: transparent;
		}
		.div_404_img{
			padding: 0px 0px;
			min-height: 50vh;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			margin: auto;
			img{
				width: 100%;
			}
		}
		.div_sorry_text {
			margin-top: 22px;
			font-size: 24px;
		}
		.div_looking_text {
			margin: auto;
			margin-top: 10px;
		   font-size: 15px;
		}
		.div_404_btn_box{
			margin: auto;
			margin-top: 10px;
			width: 100%;
			max-width: 320px;
			padding: 20px 0px;
			display: flex;
			align-items: center;
			/* flex-direction: column; */
		}
		.go_to_support {
			margin-left: 10px;
		}
	}
</style>
